import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "../Styles/Navbar.css";
import wpsLogo from "../Images/logo.png";

function Navbar() {
  const navRef = useRef();
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNavbar = () => setIsNavOpen(!isNavOpen);
  const closeNavbar = () => setIsNavOpen(false);

  return (
    <div style={{ position: "sticky", top: 0, zIndex: 1000 }}>
      <div className="nav-email-bar">
        <a href="mailto:info@precisionworks.ca">info@precisionworks.ca</a>
      </div>
      <header>
        <div className="nav-logo">
          <a href="/"><img src={wpsLogo} alt="Windsor Precision Works" /></a>
        </div>
        <nav ref={navRef} className={isNavOpen ? "nav-open" : ""}>
          <Link to="/" onClick={closeNavbar}>Home</Link>
          <Link to="/services" onClick={closeNavbar}>Services</Link>
          <Link to="/capabilities" onClick={closeNavbar}>Capabilities</Link>
          <Link to="/industries" onClick={closeNavbar}>Industries</Link>
          <Link to="/contact" onClick={closeNavbar}>Contact</Link>
          <Link to="/contact" onClick={closeNavbar} className="nav-quote-btn">Get a Quote</Link>
        </nav>
        <button className="nav-btn" onClick={toggleNavbar}>
          {isNavOpen ? <FaTimes /> : <FaBars />}
        </button>
      </header>
    </div>
  );
}

export default Navbar;
